import { lazy, Suspense, useEffect } from 'react';
import { useLocation, useParams } from 'react-router';

/**
 * Páginas públicas de carrinho, checkout e pedido, dentro da loja virtual (`StoreRoutes`, mesmo prefixo da vitrine):
 *   /loja/:orgSlug/carrinho            -> <CartRoute />
 *   /loja/:orgSlug/checkout            -> <CheckoutRoute />
 *   /loja/:orgSlug/pedido/:orderId     -> <OrderRoute />
 * Os endereços antigos `/s/:orgSlug/(carrinho|checkout|pedido/:id)` (e-mails já enviados) redirecionam para estes.
 * Precisam estar dentro de Providers (QueryClient, Router, ConfirmProvider).
 */
export function LegacyStoreRedirect({ page }: { page: 'carrinho' | 'checkout' | 'pedido' | 'devolucoes' | 'devolucao-pedido' | 'devolucao' }) {
  const { orgSlug = '', orderId, returnId } = useParams();
  const { search } = useLocation();
  const id = orderId ?? returnId;
  const target = `/loja/${orgSlug}/${page}${id ? `/${id}` : ''}${search}`;
  // a loja é outra aplicação (providers próprios): recarrega em vez de navegar dentro do painel
  useEffect(() => window.location.replace(target), [target]);
  return null;
}

const Cart = lazy(() => import('./pages/cart-page').then((m) => ({ default: m.CartPage })));
const Checkout = lazy(() => import('./pages/checkout-page').then((m) => ({ default: m.CheckoutPage })));
const Order = lazy(() => import('./pages/order-page').then((m) => ({ default: m.OrderPage })));

export function CartRoute() {
  return (
    <Suspense fallback={null}>
      <Cart />
    </Suspense>
  );
}
export function CheckoutRoute() {
  return (
    <Suspense fallback={null}>
      <Checkout />
    </Suspense>
  );
}
export function OrderRoute() {
  return (
    <Suspense fallback={null}>
      <Order />
    </Suspense>
  );
}

export { CartDrawer } from './components/cart-drawer';
export { addToCart, cartHref, clearCart, removeFromCart, useCart } from './cart-store';
